import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import { v1 as uuidv1 } from 'uuid'

import { withTranslation } from 'react-i18next'

import AlertMessage from '../../components/AlertMessage'
import PageLoader from '../../components/PageLoader'
import usersActions from './actions'
import UserRow from './UserRow'

class UsersTable extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props

    dispatch(usersActions.fetchAll())
  }

  render() {
    const {
      currentUserEmail,
      currentUserRole,
      dispatch,
      fetchingStatus,
      onUserEdit,
      onUserRemove,
      sendEmailStatus,
      sendEmailUserId,
      t,
      users
    } = this.props

    if (fetchingStatus === 'fetching' || users === null) {
      return (
        <div className={`d-flex flex-row flex-fill justify-content-center
                         align-items-center`}
        >
          <PageLoader message={t('UsersTable.fetching')} />
        </div>
      )
    }

    if (fetchingStatus === 'failed') {
      return (
        <div className={`d-flex flex-row flex-fill justify-content-center
                         align-items-center`}
        >
          <AlertMessage>
            {t('UsersTable.errors.fetchUsersFailed')}
          </AlertMessage>
        </div>
      )
    }

    return (
      <Table className="mt-3 align-middle">
        <thead>
          <tr>
            <th>{t('UsersTable.headers.email')}</th>
            <th>{t('UsersTable.headers.role')}</th>
            <th>{t('UsersTable.headers.memberSince')}</th>
            <th aria-label="Actions" />
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <UserRow
              canEdit={currentUserRole === 'admin'}
              canRemove={users.length > 1 && (currentUserRole === 'admin' || user.email === currentUserEmail)}
              canSendEmail={currentUserRole === 'admin'}
              currentUserEmail={currentUserEmail}
              isSendingEmail={sendEmailStatus === 'sending' && sendEmailUserId === user.id}
              key={uuidv1()}
              onEdit={(id) => onUserEdit(id)}
              onRemove={(id) => onUserRemove(id)}
              onSendEmail={(id) => dispatch(usersActions.sendEmail(id))}
              user={user}
            />
          ))}
        </tbody>
      </Table>
    )
  }
}

UsersTable.propTypes = {
  currentUserEmail: PropTypes.string,
  currentUserRole: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  fetchingStatus: PropTypes.string,
  onUserEdit: PropTypes.func.isRequired,
  onUserRemove: PropTypes.func.isRequired,
  sendEmailStatus: PropTypes.string,
  sendEmailUserId: PropTypes.string,
  t: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(PropTypes.object)
}

UsersTable.defaultProps = {
  currentUserEmail: null,
  currentUserRole: null,
  fetchingStatus: 'idle',
  sendEmailStatus: 'idle',
  sendEmailUserId: null,
  users: null
}

const mapStateToProps = ({
  authentication: {
    email: currentUserEmail,
    role: currentUserRole
  },
  users: {
    fetchingStatus,
    items: users,
    sendEmailStatus,
    sendEmailUserId
  }
}) => ({
  currentUserEmail,
  currentUserRole,
  fetchingStatus,
  sendEmailStatus,
  sendEmailUserId,
  users
})

export default withTranslation('UsersPage')(
  connect(mapStateToProps)(UsersTable)
)
